import React, { useState, useEffect } from "react";
import { makeStyles } from "@material-ui/core/styles";
// import MaskText from "../components/MaskText";
import Toast from "../components/Toast";
import { useHistory, useLocation } from "react-router-dom";
import {
  TextField,
  Button,
  Grid,
  Typography,
  Divider,
  LinearProgress,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
// import service_icon from "../car-service.png";
// import icon from "../invoice.png";
import {
  dataProvider,  
  getSettings,
  getPDF_,
  config,
} from "../util";
import AlertDialog from "../components/AlertDialog";

// import * as Scroll from 'react-scroll';
import { scroller } from "react-scroll";
// import WhatsAppIcon from '@material-ui/icons-material/WhatsApp';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
// import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import DataTable from "../components/DataTable";
import BasicDataTable from "../components/BasicDataTable";
import Swal from "sweetalert2";
import {
  Description,
} from "@material-ui/icons";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    padding: 30,
    // background: "#f3f3f3"
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "left",
    color: theme.palette.text.secondary,
  },
  formRoot: {
    "& > *": {
      //   margin: theme.spacing(1),
      //   minWidth: '100%',
      //   background: 'red'
    },
  },
  flow: {
    width: "100%",
  },
  icon: {
    color: "red",
  },
  section1: {
    marginTop: 20,
  },
  subTitle: {
    color: "#0635C9",
    textAlign: "left",
    fontSize: "1.2em",
  },
  hint: {
    color: "#aaa",
  },
}));

export default function ViewEstimate() {
  let history = useHistory();
  const classes = useStyles();
  // const [formData, setFormData] = React.useState({});
  const [formData, setFormData] = React.useState({rate_hour:0, work_hour:0});
  const [totals, setTotals] = React.useState({
    product: 0,
    labour: 0,
    total: 0,
  });
  // const [payment, setPayment] = React.useState();

  // const [state, dispatch] = useReducer(reducer, {})
  function useQuery() {
    return new URLSearchParams(useLocation().search);
  }

  const [serviceRequest, setServiceRequest] = React.useState({});
  // const [paid, setPaid] = React.useState(false);
  const [query_id, setQueryID] = React.useState(useQuery().get("id"));
  const [loading, setLoading] = React.useState(true);
  const [profile, setProfile] = React.useState({}); //List of Company Products
  const [products, setProducts] = React.useState([]); //List of Company Products
  const [services, setServices] = React.useState([]); //List of Company Services
  // const [invoiceData, setInvoiceData] = React.useState("");
  const [productInvoice, setProductInvoice] = React.useState([]); //Product added to this invoice
  const [serviceInvoice, setServiceInvoice] = React.useState([]); //Services added to this invoice

  const [option, setOption] = useState({ title: "Products", id: "active" });
  var queryID = useQuery().get("id");
  //AlertDialog ----------------------------------------
  const [isOpen, setIsOpen] = React.useState(false);
  const handleDialogOpen = () => {
    setIsOpen(true);
  };
  const handleDialogClose = () => {
    setIsOpen(false);
  };

  const paymentDialog = async (trans) => {
    const { value: payment } = await Swal.fire({
      title: "Receive Payment",
      input: "number",
      html: "<div style='text-align:left;'>Amount to Pay</div>",
      inputValue: totals.total,
      inputAttributes: {
        max: totals.total,
      },
      showCancelButton: true,
      confirmButtonText: "Save Payment",
      inputValidator: (value) => {
        if (!value) {
          return "You need to have a value";
        }
      },
    });

    if (payment) {
      console.log(payment);
      makePayment({
        ...trans,
        invoice_id: queryID,
        amount: payment,
        vin: serviceRequest.vin,
      });
    }
  };

  const applyDiscount = async (trans) => {
    const inputOptions = new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          0: "",
          5: "5%",
          6: "6%",
          7: "7%",
          8: "8%",
          9: "9%",
          10: "10%",
          11: "11%",
          12: "12%",
          13: "13%",
          14: "14%",
          15: "15%",
          16: "16%",
          17: "17%",
          18: "18%",
          19: "19%",
          20: "20%",
        });
      }, 200);
    });

    const { value: disc } = await Swal.fire({
      title: "Select discount",
      input: "select",
      inputOptions: inputOptions,
      html: '<div id="calc_discount"></div>',
      didOpen: (dom) => {
        Swal.getInput().onchange = function (event) {
          // console.log(event.target.value);
          // if (event.target.value === "Others") {
          dom.querySelector("#calc_discount").innerHTML = (
            (totals.labour + totals.product) *
            (event.target.value / 100)
          ).toLocaleString("en-US", {
            style: "currency",
            currency: "USD",
          });
          // } else {
          //   dom.querySelector('#fruit-text').style.display = 'none'
          // }
        };
      },
      showCancelButton: true,
      inputValidator: (value) => {
        if (!value) {
          return "You need to choose something!";
        }
      },
    });

    if (disc) {
      // Swal.fire({ html: `You selected: ${disc}` })
      // makeDiscount({
      //   ...trans,
      //   invoice_id: queryID,
      //   amount: (totals.labour + totals.product) * (disc / 100),
      //   vin: serviceRequest.vin,
      // });
    }
  };

  /* Save Payment */
  const makePayment = async (data) => {
    // console.log(data);
    // console.log(data.replace("#", ""));
    // let state = e;
    // if (e.target) state = e.target.value;
    if (!data) return;

    try {
      const mydata = await dataProvider("post", "/transaction", data);
      setToastMessage(mydata.data.message);
      setIsToastOpen(true);
      // loadData();
      fetchInvoice();
    } catch (error) {
      console.log(error);
      setToastMessage(error.message);
      setIsToastOpen(true);
    }
  };
  /* Save Discount */
  const makeDiscount = async (data) => {
    console.log(data);
    // console.log(data.replace("#", ""));
    // let state = e;
    // if (e.target) state = e.target.value;
    if (!data) return;

    try {
      const mydata = await dataProvider("post", "/discount", data);
      setToastMessage(mydata.data.message);
      setIsToastOpen(true);
      // loadData();
      fetchInvoice();
    } catch (error) {
      console.log(error);
      setToastMessage(error.message);
      setIsToastOpen(true);
    }
  };

  const scrolly = (ele) => {
    scroller.scrollTo(ele, {
      duration: 800,
      delay: 0,
      smooth: "easeInOutQuart",
      offset: -90,
    });
  };
  const handleDialogAgree = () => {
    setIsOpen(false);
    // if (!formData.work_hour || formData.work_hour.length < 1) {
    //   doToast("Enter work hours");
    //   scrolly("work_hour");
    //   return false;
    // }
    // if (!formData.rate_hour || formData.rate_hour.length < 1) {
    //   doToast("Enter rate/hour");
    //   scrolly("rate_hour");
    //   return false;
    // }

    dataProvider("put", "/estimate-details", {
      id: query_id,
      profile,
      formData,
      productInvoice,
      serviceInvoice,
      totals,
    })
      .then((res) => {
        // if (res.data.data.invoice_id) {
        //   setToastMessage(res.data.message);
        //   setIsToastOpen(true);
        // } else {
        // console.log(res.response, "imple")
        setToastMessage(res.data.message);
        setIsToastOpen(true);
        // }
      })
      .catch((error) => {
        setToastMessage(error.message);
        setIsToastOpen(true);
        //  window.location = "/login";
      });
  };

  const saveChanges = () => {

       if (!profile.first_name || profile.first_name.length < 1) {
      doToast("Enter first name");
      scrolly("first_name");
      return false;
    }
       if (!profile.last_name || profile.last_name.length < 1) {
      doToast("Enter last name");
      scrolly("last_name");
      return false;
    }

    if (serviceInvoice.length < 1) {
      doToast("Select at least one service");
      // scrolly("first_name");
      return false;
    }
    // if (!formData.rate_hour || formData.rate_hour.length < 1) {
    //   doToast("Enter rate/hour");
    //   scrolly("rate_hour");
    //   return false;
    // }


    dataProvider("put", "/estimate-details", {
      id: query_id,
      profile,
      formData,
      productInvoice,
      serviceInvoice,
      totals,
    })
      .then((res) => {
        // if (res.data.data.invoice_id) {
        //   setToastMessage(res.data.message);
        //   setIsToastOpen(true);
        // } else {
        // console.log(res.response, "imple")
        setToastMessage(res.data.message);
        setIsToastOpen(true);
        history.push(`/view-estimate?id=${query_id}`)
        // }
      })
      .catch((error) => {
        setToastMessage(error.message);
        setIsToastOpen(true);
        //  window.location = "/login";
      });
  }
  const reset = () => {
    Array.from(document.querySelectorAll("input")).forEach(
      (input) => (input.value = "")
    );
    setFormData({});
  };

  const doToast = (message) => {
    setToastMessage(message);
    setIsToastOpen(true);
  };
  const handleDialogCancel = () => {
    // window.alert('cancel');
    setIsOpen(false);
  };
  // -----------------------------------------------------

  //Toast ----------------------------------------
  const [isToastOpen, setIsToastOpen] = React.useState(false);
  const [toastMessage, setToastMessage] = React.useState("");
  const handleToastClose = () => {
    setIsToastOpen(false);
  };
  // -----------------------------------------------------

  //Update work hours Labour Total
  const handleFormChange = (event) => {
    if (event.target.name === "work_hour") {
      updateWorkHour(event.target.value);
    }
    if (event.target.name === "rate_hour") {
      updateRateHour(event.target.value);
    }
    setFormData({ ...formData, [event.target.name]: event.target.value });
  };

  const updateProfileState = (e) => {

    if(e.target.name === 'contact'){
      if(e.target.value?.length > 11) return false;
    }
    setProfile({ ...profile, [e.target.name]: e.target.value });

  }

  const updateWorkHour = (hours) => {
    if (hours < 0) return false;
    var labour_total = formData.rate_hour * hours;
    /* set product total */
    var product_total = 0;
    productInvoice.forEach((element) => {
      product_total += element.qty * element.price;
    });
    var all_total = labour_total + product_total;
    setTotals({
      ...totals,
      product: product_total,
      total: all_total,
      labour: labour_total,
    });
    setFormData({ ...formData, work_hour: hours });
    // console.log(formData);
    // reCalculateTotals();
  };
  const updateRateHour = (rate) => {
    if (rate < 0) return false;
    var labour_total = formData.work_hour * rate;
    /* set product total */
    var product_total = 0;
    productInvoice.forEach((element) => {
      product_total += element.qty * element.price;
    });
    var all_total = labour_total + product_total;
    setTotals({
      ...totals,
      product: product_total,
      total: all_total,
      labour: labour_total,
    });
    setFormData({ ...formData, rate_hour: rate });
    // console.log(formData);
    // reCalculateTotals();
  };

  useEffect(() => {
    scrolly("pageTop");

    fetchInvoice();
    // getJob();
    loadProducts(); // Products inventory
    loadServices(); //Scott's services offered

    
  }, []);

  const initValues = async() => {
    let rate = await getSettings().rate;
    updateRateHour(rate);
  }


  useEffect(()=>{
console.log(query_id, "new qID")
  },[query_id])


  // Update Totals when product list is modified
  useEffect(() => {
    /* set product total */
    // reCalculateTotals();
    /* set product total */
    var product_total = 0;
    productInvoice.forEach((element) => {
      //  console.log(element, "ele");
      product_total += element.qty * element.price;
    });
    var all_total = totals?.labour + product_total;
    setTotals({ ...totals, product: product_total, total: all_total });
    // setTotals({...totals})
  }, [productInvoice]);


    // Update Totals when product list is modified
    /*
    useEffect(() => {
      var service_total = 0;
      serviceInvoice.forEach((element) => {
        //  console.log(element, "ele");
        service_total += element.qty * element.price;
      });
      var all_total = totals?.product + service_total;
      setTotals({ ...totals, labour: service_total, total: all_total });
      // setTotals({...totals})
    }, [serviceInvoice]);
*/
  /**
   * Re-calculate product total and consequently all TOTALS
   * @returns object
   */
  const reCalculateTotals = () => {
    var product_total = 0;
    productInvoice.forEach((element) => {
      //   console.log(element.price, "ele");
      product_total += element.qty * element.price;
    });
    // console.log("Just did pro tot", product_total);
    var all_total = totals?.labour + product_total;
    setTotals({ ...totals, product: product_total, total: all_total });
  };

  /**
   * Get Job details
   * @returns null
   */
  function getJob(id) {
    // if (!queryID) return;

    dataProvider("post", "/booking", { id: id })
      .then((res) => {
        // console.log(res.status," RES")
        if (res.message === "Network Error") throw new Error(res.message);

        if (res.data) {
          // console.log(res.data[0] , "profile-sr");
          setServiceRequest(res.data[0]);
        } else {
          alert("No record found " + id);
          //   history.goBack();
        }
      })
      .catch((error) => {
        console.log(error, "post");
        setToastMessage(error);
        setIsToastOpen(true);
        //  window.location = "/login";
      });
  }

  /**
   * Get Invoice Data
   * @returns object
   */
  async function fetchInvoice() {

    // var qID = queryID;
    if (!queryID) { //no id so do insert

      try {
        var est = await dataProvider("post", "/estimate/", {})
        // console.log(est.data.data, "estimateeeeeeeeee")
        queryID = est.data.data.invoice_id;
        setQueryID(queryID);
        initValues();
        setLoading(false);
        return;
      } catch (error) {
        console.log(error)
      }
      
      
     
    };

    setLoading(false);

    

    dataProvider("get", "/estimate/" + queryID, {})
      .then((res) => {
        // console.log(res.status," RES")
        if (res.message === "Network Error") throw new Error(res.message);

        if (res.data) {
          //   setPreInvoice(res.data[0]);
          //fetch and set LIVE service requests
          // getJob(JSON.parse(res.data[0].profile).id); //not needed for estimate
          //set products used

          console.log(res.data[0]," RES")

          setProfile(JSON.parse(res.data[0].profile?res.data[0].profile:[]));
          
           setProductInvoice(JSON.parse(res.data[0].products?res.data[0].products:[]));
          //set services used
           setServiceInvoice(JSON.parse(res.data[0].services?res.data[0].services:[]));

          //set invoiceToken
          // setInvoiceData({ token: res.data[0].token });
          //update work hour
          updateWorkHour(res.data[0].work_hour);
          //update rate hour
          updateRateHour(res.data[0].rate_hour);
          //set form Data (Work hour)
          setFormData({
            work_hour: res.data[0].work_hour?res.data[0].work_hour:0,
            rate_hour: res.data[0].rate_hour?res.data[0].rate_hour:0,
            discount: res.data[0].discount?res.data[0].discount:0,
          });

          // let new_total = res.data[0].totals.total - res.data[0].payment;
          // setFullTotal({total:new_total, payment:res.data[0].payment});
          // setPayment(res.data[0].payment);
          let totals_obj = JSON.parse(res.data[0].totals?res.data[0].totals:{});
          setTotals(totals_obj); //apply original saved totals

          //Check if  full payment was made
          // console.log(totals_obj.total +" -" +res.data[0].payment);

          // if (totals_obj.total <= 0) {
          //   setPaid(true);
          // }
        } else {
          alert("No record found " + queryID);
          //   history.goBack();
        }
      })
      .catch((error) => {
        console.log(error, "get estimate/");
        // setToastMessage(error);
        // setIsToastOpen(true);
        //  window.location = "/login";
      });
  }

  /**
   * Get all Products
   * @returns object
   */
  async function loadProducts() {
    try {
      const mydata = await dataProvider("get", "/products", []);
      setProducts(mydata.data);
    } catch (error) {
      // console.log(error.message);
      setToastMessage("Request failed - Products");
      setIsToastOpen(true);
    }
  }  
  
  /**
   * Get all Services
   * @returns object
   */
  async function loadServices() {
    try {
      const mydata = await dataProvider("get", "/services", []);
      setServices(mydata.data);
    } catch (error) {
      console.log(error);
      // setToastMessage(error.message);
      setToastMessage("Request failed - Services");
      setIsToastOpen(true);
    }
  }

  function mainTableUp(v) {
    if (v[0]?.qty < 1) return false;
    // console.log(v, "------------");

    /* set product total */
    var product_total = 0;
    productInvoice.forEach((element) => {
      //   console.log(element, "ele");
      product_total += element.qty * element.price;
    });
    // var all_total = totals?.labour + product_total;
    var all_total = totals?.service + product_total;
    setTotals({ ...totals, product: product_total, total: all_total });
    setProductInvoice([...v]);
  }
  
  function servicesTableUp(v) {

    /*
    if (v[0]?.qty < 1) return false;
    // set product total 
    var service_total = 0;
    serviceInvoice.forEach((element) => {
      service_total += element.qty * element.price;
    });
    var all_total = service_total + totals?.product;
    setTotals({ ...totals, labour: service_total, total: all_total });
    */
    setServiceInvoice([...v]);
  }

  function refreshData() {
    console.log(3);
  }
  return loading === false? (
    <div className={classes.root} id="pageTop">
      <form className={classes.formRoot} autoComplete="off">
        <Grid container spacing={3} style={{ paddingTop: 30 }}>
          <Grid item xs={12}>
            <div className={classes.section1}>
              <Grid container alignItems="center">
                <Grid item xs>
                  <Typography
                    gutterBottom
                    variant="h2"
                    style={{ fontSize: "2em" }}
                  >
                    Estimate #{query_id}
                  </Typography>
                </Grid>
                {/* <Grid item>1
                  <Typography gutterBottom variant="h6">
                    $4.50
                  </Typography>
                </Grid> */}
              </Grid>

              <Divider
                style={{
                  marginTop: 15,
                  background: "#f1f1f1",
                }}
              />
            </div>
          </Grid>
          {/* <Grid item xs={12}>
            <div className={classes.section1}>
              <Grid container alignItems="center">
                <Grid item xs>
           
                  <img alt="product" src={icon} width={60} />
                  <Typography gutterBottom variant="h5">
                    {serviceRequest?.first_name +
                      " " +
                      serviceRequest?.last_name}
                  </Typography>
                </Grid>
          
              </Grid>
              <Typography color="textSecondary" variant="body2">
                Enter work hours and select products used for this job.
              </Typography>
          
            </div>
          </Grid> */}

          <Grid item sm={6} style={{ textAlign: "left" }}>
          <TextField
              className={classes.flow}
              variant="outlined"
              label="First Name"
              value={profile.first_name}
              name="first_name"
              autoComplete="off"
              InputLabelProps={{
                shrink: true,
              }}
              onChange={updateProfileState}
            />
          </Grid>
          <Grid item sm={6} style={{ textAlign: "left" }}>
       
            <TextField
            className={classes.flow}
            variant="outlined"
            label="Last Name"
            value={profile.last_name}
            autoComplete="off"
            InputLabelProps={{
              shrink: true,
            }}
            name="last_name"
            onChange={updateProfileState}
          />
          </Grid>

          <Grid item sm={6} style={{ textAlign: "left" }}>
            <TextField
              className={classes.flow}
              variant="outlined"
              label="Enter contact#"
              value={profile.contact}
              autoComplete="off"
              InputLabelProps={{
                shrink: true,
              }}
              name="contact"
              onChange={updateProfileState}
            />
          </Grid>

          <Grid item sm={6} style={{ textAlign: "left" }}>
            <TextField
              className={classes.flow}
              variant="outlined"
              label="Email"
              value={profile.email}
              autoComplete="off"
              InputLabelProps={{
                shrink: true,
              }}
              name="email"
              onChange={updateProfileState}
            />
          </Grid>

          {/* <Grid item sm={12} style={{ textAlign: "left" }}>
            <small className={classes.hint}>Services</small>
            <Typography variant="subtitle1" color="primary">
              {serviceRequest.service}{" "}
            </Typography>
          </Grid> */}

         <Grid item xs={12} md={3} style={{ textAlign: "left" }}>
            <TextField
              label="Enter work hours"
              name="work_hour"
              id="work_hour"
              variant="outlined"
              className={classes.flow}
              value={formData.work_hour}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  return handleFormChange(e);
                }
              }}
              // disabled={payment === 0 ? false : true}
              required
              type="number"
              inputProps={{ maxLength: 9, min: 0 }}
              autoComplete="off"
            />
            <small className={classes.hint}>
              {formData.rate_hour?.toLocaleString("en-US", {
                style: "currency",
                currency: "USD",
              }) + "/hr"}
            </small>
          </Grid> 

          <Grid item xs={12} md={3} style={{ textAlign: "left" }}>
            <TextField
              label="Enter rate/hour"
              name="rate_hour"
              id="rate_hour"
              variant="outlined"
              className={classes.flow}
              value={formData.rate_hour}
              onChange={(e) => {
                if (e.target.value >= 0) {
                  return handleFormChange(e);
                }
              }}
              // disabled={payment === 0 ? false : true}
              required
              type="number"
              inputProps={{ maxLength: 9, min: 0, max: 9999999999, step: 1 }}
              autoComplete="off"
            />
          </Grid>

          {/* <Grid item xs={12} md={3} style={{ textAlign: "left" }}>
          <InputLabel id="discount_label">Apply discount</InputLabel>
        <Select
          labelId="discount"
          id="discount"
          name="discount"
          value={formData.discount}
          onChange={handleFormChange}
          label="Apply discount"
        >
          <MenuItem value={0}>
            <em>None</em>
          </MenuItem>
          <MenuItem value={500}>Five Hundred ($500)</MenuItem>
          <MenuItem value={1000}>One Thousand ($1,000)</MenuItem>
          <MenuItem value={1500}>One Thousand Five Hundred ($1,500)</MenuItem>
        </Select>
        
          </Grid> */}

          <Grid item xs={12} md={6}>
         
              {/* <DataTable
              data={productInvoice}
              refresher={refreshData}
              option={option}
              tableUp={mainTableUp}
              active={payment === 0 ? false : true}
            /> */}
          </Grid>
        </Grid>

        <Grid container spacing={3}>
          <Grid item xs={12} md={6} style={{ marginTop: 15 }}>
          <Autocomplete
              id="product"
        
              // disabled={payment === 0 ? false : true}
              //   onChange={productUpdate}
              onChange={(event, newValue) => {
                if (!newValue) return;
                var filtr = productInvoice.filter(
                  (item) => item.id === newValue.id
                );
                if (filtr.length > 0) return; // product already in the list dont add
                var newTableData = productInvoice;
                newTableData.splice(0, 0, { qty: 1, ...newValue }); //add new product to the top of invoice
                setProductInvoice([...newTableData]);
                // setProductValue(productValue);
              }}
              //   value={productValue}
              options={products}
              getOptionLabel={(option) => {
                return (
                  option.title +
                  " - " +
                  option.price.toLocaleString("en-US", {
                    style: "currency",
                    currency: "USD",
                  })
                );
              }}
              renderOption={(option) => (
                <React.Fragment>
                  <div>{option.title}</div>&nbsp;
                  <small style={{ color: "#999", float: "right" }}>
                    ({option.description})
                  </small>
                  &nbsp;-&nbsp;
                  <small
                    style={{
                      color: "#1a6ba8",
                      float: "right",
                      fontWeight: 700,
                    }}
                  >
                    {option.price.toLocaleString("en-US", {
                      style: "currency",
                      currency: "USD",
                    })}
                  </small>
                </React.Fragment>
              )}
              //   style={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose products"
                  variant="outlined"
                />
              )}
            />

            <div style={{paddingTop:20}}>
            <DataTable
            
            data={productInvoice}
            refresher={refreshData}
            option={option}
            tableUp={mainTableUp}
            active={false}
            // active={payment === 0 ? false : true}
          />
              </div>
          
          </Grid>

          {/* Services */}

          <Grid item xs={12} md={6} style={{ marginTop: 15 }}>
          <Autocomplete
              id="services"
        
              // disabled={payment === 0 ? false : true}
              //   onChange={productUpdate}
              onChange={(event, newValue) => {
                if (!newValue) return;
                var filtr = serviceInvoice.filter(
                  (item) => item.id === newValue.id
                );
                if (filtr.length > 0) return; // product already in the list dont add
                var newTableData = serviceInvoice;
                newTableData.splice(0, 0, { qty: 1, ...newValue }); //add new product to the top of invoice
                setServiceInvoice([...newTableData]);
                // setProductValue(productValue);
              }}
              //   value={productValue}
              options={services}
              getOptionLabel={(option) => {
                return (
                  option.title
                );
              }}
              renderOption={(option) => (
                <React.Fragment>
                  <div>{option.description}</div>&nbsp;
                  <small style={{ color: "#999", float: "right" }}>
                    ({option.description})
                  </small>
                  
                </React.Fragment>
              )}
              //   style={{ width: 300 }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Choose services"
                  variant="outlined"
                />
              )}
            />

            <div style={{paddingTop:20}}>
            <BasicDataTable
            
            data={serviceInvoice} //serviceInvoice
            refresher={refreshData}
            option={{ title: "Services", id: "active" }}
            tableUp={servicesTableUp}
            active={false}
            // active={payment === 0 ? false : true}
          />
              </div>
          
          </Grid>


          <Grid
            item
            xs={12}
            md={6}
            style={{ textAlign: "left", marginTop: 15 }}
          >
            <div>
              <TableContainer component={Paper}>
                <Table className={classes.table} aria-label="simple table">
                  <TableBody>
                    <TableRow key="1">
                      <TableCell align="left">
                        <b>Products Total</b>
                      </TableCell>
                      <TableCell align="left">
                        {totals?.product.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                      </TableCell>
                    </TableRow>
                    <TableRow key="2">
                      <TableCell align="left">
                        <div>
                          <b>Labour Total</b>
                        </div>
                        {/* <small>
                          {formData.rate_hour
                            ? formData.rate_hour.toLocaleString("en-US", {
                                style: "currency",
                                currency: "USD",
                              }) + " / hr"
                            : formData.rate_hour}
                        </small> */}
                      </TableCell>
                      <TableCell align="left">
                        {totals.labour.toLocaleString("en-US", {
                          style: "currency",
                          currency: "USD",
                        })}
                      </TableCell>
                    </TableRow>
                    {/* <TableRow key="3" style={{ background: "#F5FCD9" }}>
                      <TableCell align="left">
                        <div>
                          <b>Amount Paid</b>
                        </div>
            
                      </TableCell>
                      <TableCell align="right" style={{ color: "green" }}>
                        <strong>
                          {payment?.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                        </strong>
                      </TableCell>
                    </TableRow> */}
{/* 
                    <TableRow key="4" style={{ background: "#eaf8ff" }}>
                      <TableCell align="left">
                        <div>
                          <b>Discount</b>
                        </div>
                        
                      </TableCell>
                      <TableCell align="right" style={{ color: "#222" }}>
                        <strong>
                          {formData.discount?.toLocaleString("en-US", {
                            style: "currency",
                            currency: "USD",
                          })}
                        </strong>
                      </TableCell>
                    </TableRow> */}

                    <TableRow key="5">
                      <TableCell align="left">
                        <b>Total Due</b>
                      </TableCell>
                      <TableCell align="left">
                        <strong
                          style={{
                            fontSize: "1.2em",
                            color: totals.total === 0 ? "#222" : "#F50359",
                          }}
                        >
                          {/* {totals.total === 0 ? (
                            <div style={{ color: "green" }}>PAID</div>
                          ) : ( */}

                          {
                            totals.total.toLocaleString("en-US", {
                              style: "currency",
                              currency: "USD",
                            })
                          }
                            
                          {/*  )} */}
                        </strong>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                </Table>
              </TableContainer>

              <Grid item xs={12} style={{ marginTop: 9, padding: 5 }}>
                <Paper style={{ padding: 3, backgroundColor: "#f6f6f6" }}>
                  <Button
                    variant="contained"
                    size="large"
                    onClick={() => history.push("/view-estimates")}
                    style={{ margin: 9 }}
                  >
                    View Estimates
                  </Button>
                  <Button
                    variant="contained"
                    size="large"
                    // color="primary"
                    onClick={
                      () => getPDF_(config.domain + "estimate-pdf/" + query_id)
                      // getPDF_(config.domain + "invoice-pdf/" + queryID)
                      // console.log(config.domain + "invoice-pdf/" + queryID)
                    }
                    style={{ margin: 9 }}
                    startIcon={<Description />}
                  >
                    Print Estimate
                  </Button>
           
                  {/* <Button
                    variant="contained"
                    size="large"
                    // color="primary"
                    onClick={() => applyDiscount({ method: "discount" })}
                    style={{ margin: 9, display: paid === true ? "none" : "" }}
                    startIcon={<MoneyOff />}
                  >
                    Apply Discount
                  </Button> */}
                  <Button
                    variant="contained"
                    size="large"
                    color="primary"
                    onClick={saveChanges}
                    // style={{ margin: 9, display: paid === true ? "none" : "" }}
                  >
                    Save Changes
                  </Button>
                </Paper>
              </Grid>

              {/* <Grid
                item
                xs={12}
                style={{
                  marginTop: 19,
                  padding: 5,
                  display: paid === true ? "none" : "",
                }}
              >
                12
              </Grid> */}
            </div>
          </Grid>
        </Grid>

        {/* <Grid container spacing={3}>
         
        </Grid> */}
      </form>
      <AlertDialog
        isOpen={isOpen}
        handleClose={handleDialogClose}
        handleAgree={handleDialogAgree}
        handleCancel={handleDialogCancel}
        title={
          "Scott's Auto -  Invoice for " +
          serviceRequest.first_name +
          " " +
          serviceRequest.last_name
        }
        subtitle="Are you sure you want to continue?"
      />
      <Toast
        isOpen={isToastOpen}
        handleClose={handleToastClose}
        message={toastMessage}
      />
    </div>
  ) : (
    <LinearProgress style={{ marginTop: 60 }} />
  );
}
